import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
/**
 * The single place that decides where an edit route returns to. The list hands over its
 * own URL - filters, page and open detail included - when it opens the editor, so the
 * editor never has to rebuild that address from parts and lose half of it.
 */
export var useEditNavigation = function () {
    var history = useHistory();
    var location = useLocation();
    return useCallback(function (editPath) {
        var listUrl = "".concat(location.pathname).concat(location.search);
        history.push(editPath, { listUrl: listUrl });
    }, [history, location.pathname, location.search]);
};
/**
 * Returns to the list the editor was opened from. An editor reached by useEditNavigation's
 * push goes back instead of pushing the list again: the previous entry is exactly listUrl,
 * and a second push would leave the editor in the history, so a later Back (the detail
 * page's "Zpět" is history.goBack) would land in the form again. A reloaded editor (POP,
 * the state survives a reload) or one opened from a pasted URL pushes listUrl or the
 * fallback, because the previous entry is unknown there.
 */
export var useListReturn = function (fallbackUrl) {
    var history = useHistory();
    var location = useLocation();
    return useCallback(function () {
        var _a;
        var listUrl = (_a = location.state) === null || _a === void 0 ? void 0 : _a.listUrl;
        if (listUrl && history.action === "PUSH") {
            history.goBack();
        }
        else {
            history.push(listUrl !== null && listUrl !== void 0 ? listUrl : fallbackUrl);
        }
    }, [history, location.state, fallbackUrl]);
};
